import { BUY_LIST_DETAIL_QUERY_KEY } from '~/api/buyList';
import { graphql } from '~/graphql';
import { useGraphqlMutation } from '~/hooks/useGraphqlMutation';
import { CART_QUERY_KEYS } from '~/utils/cartCache';

const addBuyListToCartMutation = graphql(`
  mutation AddBuyListToCart(
    $buyListId: ID!
    $sellerOrganizationFacilityId: ID!
    $locationId: ID!
    $transportVehicleId: ID
    $items: [BuyListItemSelectionInput!]!
    $tallies: [BuyListTallySelectionInput!]! = []
  ) {
    addBuyListToCart(
      buyListId: $buyListId
      sellerOrganizationFacilityId: $sellerOrganizationFacilityId
      locationId: $locationId
      transportVehicleId: $transportVehicleId
      items: $items
      tallies: $tallies
    ) {
      cart {
        id
      }
      skippedItems {
        productName
        reason
        tallyKind
        tallyName
        tallyCount
      }
    }
  }
`);

export const useAddBuyListToCart = () =>
  useGraphqlMutation(addBuyListToCartMutation, [
    ...CART_QUERY_KEYS,
    'shippingCost',
    BUY_LIST_DETAIL_QUERY_KEY,
  ]);
